import axios from 'axios';

import API from './api';

class Auth extends API {
  constructor() {
    super();

    this.$axios = axios.create({
      baseURL: '/auth/api',
    });
  }
}

const auth = new Auth();

export default auth;
